export default __webpack_public_path__ + "static/media/image-product-3.af5c71ba.jpg";